import React, { useState } from 'react';
import { callDemo, demoErrorMessage } from './demoApi';

// Touchpoint 1: "See your site's AI answer bubble"
const AnswerBubbleDemo = () => {
  const [businessType, setBusinessType] = useState('');
  const [question, setQuestion] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [answer, setAnswer] = useState('');

  const canSubmit = businessType.trim() && question.trim() && !loading;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setLoading(true);
    setError('');
    setAnswer('');
    try {
      const data = await callDemo('answer_bubble', {
        business_type: businessType.trim(),
        question: question.trim(),
      });
      setAnswer(data.answer || '');
    } catch (err) {
      setError(demoErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card demo-card">
      <div className="ic">💬</div>
      <h4>See your site's AI answer bubble</h4>
      <p className="demo-sub">Type your business type and a question a customer might ask.</p>
      <input
        className="demo-input"
        type="text"
        placeholder="Your business type (e.g. hair salon)"
        value={businessType}
        onChange={(e) => setBusinessType(e.target.value)}
        maxLength={120}
      />
      <input
        className="demo-input"
        type="text"
        placeholder="A question a customer might ask (e.g. Are you open Saturday?)"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        maxLength={300}
        onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
      />
      <button className="demo-btn" onClick={handleSubmit} disabled={!canSubmit}>
        {loading ? 'Thinking…' : 'Show me →'}
      </button>
      {error && <p className="demo-error">{error}</p>}
      {answer && (
        <div className="demo-result">
          <h5>Your AI answer bubble says</h5>
          <p>&ldquo;{answer}&rdquo;</p>
        </div>
      )}
      {answer && (
        <a href="/order" className="demo-cta">
          Want this on your own site? $199, live in 48 hours →
        </a>
      )}
      <p className="demo-privacy">🔒 Nothing you type here is saved.</p>
    </div>
  );
};

export default AnswerBubbleDemo;
